import { render, staticRenderFns } from "./BackgroundChecks.vue?vue&type=template&id=35231542&"
import script from "./BackgroundChecks.vue?vue&type=script&lang=js&"
export * from "./BackgroundChecks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports